import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomMuiBackDrop from "../../Custom/CustomMuiBackDrop";

import { Upload } from "antd";
import { useState, useEffect } from "react";
import { FileUploadDialogProps } from "./type";
import { getStandardDialogTheme } from "./utils";
import { ContinueButton } from "../../Custom/Buttons";
import { uploadBackground } from "../../../Services/API";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
} from "@mui/material";

import {
  ActionsContainer,
  HeaderContainer,
  PopupCloseIconComponent,
  StyledMuiAlert,
  UploadImageIconComponent,
  UploaderImageContainer,
  UploaderSubTextContainer,
  UploaderTextContainer,
} from "./styled";

const { Dragger } = Upload;

export default function FileUploadDialog({
  open,
  editUUID,
  submitHandler,
}: FileUploadDialogProps) {
  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [message, setMessage] = useState<any>("");
  const [severity, setSeverity] = useState<any>("");

  const beforeUpload = () => {
    return false;
  };

  const setInfo = (message: String, severity: String) => {
    setMessage(message);
    setSeverity(severity);
  };

  const onChange = ({ file }: any) => {
    setInfo("", "");

    const hasUploadedFile = fileList.length >= 1;
    const isUploadedFileValid = file.type.startsWith("image/");

    if (hasUploadedFile) {
      setFileList([]);
      setInfo("You can only upload one file!", "error");
    } else if (!isUploadedFileValid) {
      setFileList([]);
      setInfo("You can only upload image files!", "error");
    } else {
      setFileList([file]);
    }
  };

  const onRemove = () => {
    setFileList([]);
  };

  useEffect(() => {
    if (message.length) {
      setTimeout(() => {
        setInfo("", "");
      }, 3000);
    }
  }, [message]);

  const onComplete = async () => {
    if (fileList.length) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", fileList[0]);

      const backgroundURL = await uploadBackground(
        formData,
        editUUID,
        sessionStorage.principalId
      );

      if (backgroundURL?.statusCode === 200) {
        setLoading(false);
        setFileList([]);
        setInfo("File uploaded successfully!", "success");
        setTimeout(() => {
          submitHandler(backgroundURL?.data);
        }, 1000);
      } else {
        setLoading(false);
        setInfo("Error uploading file!", "error");
      }
    } else {
      setLoading(false);
      setInfo("Please select a image file!", "error");
    }
  };

  const closeHandler = () => {
    setFileList([]);
    setInfo("", "");
    setLoading(false);
    submitHandler();
  };

  return (
    <ThemeProvider theme={getStandardDialogTheme()}>
      <Dialog open={open} scroll="paper" fullWidth maxWidth="sm">
        <DialogTitle>
          <HeaderContainer>
            Upload your image
            <IconButton onClick={closeHandler}>
              <PopupCloseIconComponent />
            </IconButton>
          </HeaderContainer>
        </DialogTitle>
        <DialogContent>
          <Dragger
            beforeUpload={beforeUpload}
            fileList={fileList}
            onChange={onChange}
            onRemove={onRemove}
            showUploadList={false}
          >
            <UploaderImageContainer>
              <UploadImageIconComponent />
            </UploaderImageContainer>
            <UploaderTextContainer>
              Drag n drop to upload your image or click to browse
            </UploaderTextContainer>
            <UploaderSubTextContainer>
              (max size 1920x1080px)
            </UploaderSubTextContainer>
          </Dragger>
          {Boolean(fileList.length) && (
            <StyledMuiAlert
              color="info"
              severity="success"
              action={
                <IconButton size="small" onClick={onRemove}>
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {fileList[0].name}
            </StyledMuiAlert>
          )}
          {message && (
            <StyledMuiAlert
              severity={severity}
              action={
                <IconButton
                  size="small"
                  onClick={() => {
                    setInfo("", "");
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {message}
            </StyledMuiAlert>
          )}
          <CustomMuiBackDrop loading={loading} />
        </DialogContent>
        <DialogActions>
          <ActionsContainer>
            <ContinueButton
              onClick={onComplete}
              disabled={fileList.length === 0 || loading}
            />
          </ActionsContainer>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
